import { render, staticRenderFns } from "./eventos.vue?vue&type=template&id=2af7f139&scoped=true&"
import script from "./eventos.vue?vue&type=script&lang=js&"
export * from "./eventos.vue?vue&type=script&lang=js&"
import style0 from "./eventos.vue?vue&type=style&index=0&id=2af7f139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7f139",
  null
  
)

export default component.exports